import type { AkLocale } from '@core/types/base';

export const getLang = () => {
  return document.documentElement.lang.substring(0, 2) as AkLocale;
};
